import React from 'react'
import FilterComponent from '../../components/filter_component/View'
import i18n from 'support/i18n'

const ChallengeFilters = ({
  activeFilters, setActiveFilters,
  nameQuery, setNameQuery,
  applySearch, resetSearch,
  challengeStatus, handleFilterChange,
  isAdmin, isInnovator, localAdmin,
  classes
}) => (
  <div className={classes.mychallengeFilter}>
    <FilterComponent
      activeFilters={activeFilters}
      serviceLineOrgs={[]}
      types={[]}
      ideaStatusFilter={false}
      handleActiveFilters={setActiveFilters}
      search={nameQuery}
      setSearch={setNameQuery}
      applySearch={applySearch}
      resetSearch={resetSearch}
    />
    <div className={classes.filterContainer}>
      <span>{i18n.t('CHALLENGES.FILTER.SHOW')}:</span>
      <form>
        <select value={challengeStatus} onChange={handleFilterChange} className={classes.filterSelect}>
          <option value="ACTIVE">{i18n.t('CHALLENGES.FILTER.ACTIVE')}</option>
          {(isAdmin || isInnovator || localAdmin) && (
            <>
              <option value="DRAFT">Draft</option>
              <option value="PROPOSED">{i18n.t('CHALLENGES.FILTER.PROPOSED')}</option>
              <option value="PLANNED">{i18n.t('CHALLENGES.FILTER.COMING_SOON')}</option>
              <option value="DELETED">{i18n.t('CHALLENGES.FILTER.DELETED')}</option>
            </>
          )}
          <option value="FINISHED">{i18n.t('CHALLENGES.FILTER.FINISHED')}</option>
        </select>
      </form>
    </div>
  </div>
)

export default ChallengeFilters
